import { ReportChartConfiguration } from '@vision/ui/interfaces';
import { array, lazy, object, string } from 'yup';
import { StarChart1CompareRenderer } from '../../components';
import { DefaultReportChartThemeFont, extendDefaultChartValidationSchema } from '../default-chart.config';
import { StarChart1Measures } from './star-chart1.measures';

export const StarChart1DefaultConfiguration: ReportChartConfiguration = {
  validationSchema: extendDefaultChartValidationSchema({
    params: {
      selectedCompareCriteria: object().shape({
        selectedQuestionOptionScoreFlowIds: array()
          .of(string())
          .min(1, 'validation:rules.generic.required')
          .required('validation:rules.generic.required'),
        selectedQuestionOptionScoreQuestionIds: lazy((value) => {
          if (Array.isArray(value)) {
            return array()
              .of(string())
              .min(1, 'validation:rules.generic.required')
              .required('validation:rules.generic.required');
          }

          return string().required('validation:rules.generic.required');
        }),
      }),
    },
  }),
  measures: StarChart1Measures,
  defaultMeasure: 'star-rating',
  defaultCompares: ['question-option-score'],
  compareMultiple: false,
  compareRendererComponent: StarChart1CompareRenderer,
  customize: {
    active: (values) => !!values.selectedMeasure,
    transactionalDate: {
      active: false,
    },
    feedbackCount: {
      active: false,
    },
  },
  defaultTheme: {
    active: (values) => !!values.selectedMeasure,
    title: {
      ...DefaultReportChartThemeFont,
      label: '',
    },
  },
};
